import { render, staticRenderFns } from "./IdTypeSelectList.vue?vue&type=template&id=458bb1f0&scoped=true&"
import script from "./IdTypeSelectList.vue?vue&type=script&lang=js&"
export * from "./IdTypeSelectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458bb1f0",
  null
  
)

export default component.exports